import { GlobalData } from "../Common/GlobalData";
import { HtmlHelpers } from "../Common/HtmlHelpers";
import { TemplateHelpers } from "../Common/KendoHelpers";
import { StockPickList } from "../Common/StockPickList";

export class RelativeStrengthLineComparison {
    private static readonly GRID = '#grid';

    private readonly symbolLink = 'RelativeStrengthLine?symbol=';
    private headersInitialized = false;

    constructor() {
        this.init();
    }

    private init() {
        const stockPickList = new StockPickList(RelativeStrengthLineComparison.GRID,
            GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_RELATIVE_STRENGTH_LINE_COMPARISON);

        $(RelativeStrengthLineComparison.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            dataBound: () => {
                const data = $(RelativeStrengthLineComparison.GRID).data('kendoGrid')!.dataSource.data();
                if (!data || data.length == 0) {
                    return;
                }

                if (this.headersInitialized) {
                    return;
                }
                this.headersInitialized = true;

                this.updateColumnHeader('close',
                    HtmlHelpers.getFormattedDate(data[0].closingDate) +
                    '<br>Current<br>Close');
                this.updateColumnHeader('monthAgoClose',
                    HtmlHelpers.getFormattedDate(data[0].monthAgoClosingDate) +
                    '<br>Month<br>(4 Weeks)');
                this.updateColumnHeader('quarterAgoClose',
                    HtmlHelpers.getFormattedDate(data[0].quarterAgoClosingDate) +
                    '<br>Quarter<br>(13 Weeks)');
                this.updateColumnHeader('sixMonthsAgoClose',
                    HtmlHelpers.getFormattedDate(data[0].sixMonthsAgoClosingDate) +
                    '<br>Half Year<br>(26 Weeks)');
                this.updateColumnHeader('yearAgoClose',
                    HtmlHelpers.getFormattedDate(data[0].yearAgoClosingDate) +
                    '<br>Year<br>(52 Weeks)');
                this.updateColumnHeader('monthAgoChange',
                    HtmlHelpers.getFormattedDate(data[0].monthAgoClosingDate) +
                    '<br>Month<br>(4 Weeks)');
                this.updateColumnHeader('quarterAgoChange',
                    HtmlHelpers.getFormattedDate(data[0].quarterAgoClosingDate) +
                    '<br>Quarter<br>(13 Weeks)');
                this.updateColumnHeader('sixMonthsAgoChange',
                    HtmlHelpers.getFormattedDate(data[0].sixMonthsAgoClosingDate) +
                    '<br>Half Year<br>(26 Weeks)');
                this.updateColumnHeader('yearAgoChange',
                    HtmlHelpers.getFormattedDate(data[0].yearAgoClosingDate) +
                    '<br>Year<br>(52 Weeks)');
            },
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: TemplateHelpers.getSymbolLinkTemplate(this.symbolLink),
            }, {
                field: 'close',
                title: 'Current<br>Close',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                width: '1%',
                headerAttributes: { 'class': 'table-header-cell' },
                attributes: { 'class': 'grid-column-padding' },
            }, {
                field: 'monthAgoClose',
                title: 'Month<br>(4 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'quarterAgoClose',
                title: 'Quarter<br>(13 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'sixMonthsAgoClose',
                title: 'Half Year<br>(26 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'yearAgoClose',
                title: 'Year<br>(52 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                width: '1%',
                headerAttributes: { 'class': 'table-header-cell' },
                attributes: { 'class': 'grid-column-padding' },
            }, {
                field: 'monthAgoChange',
                title: 'Month<br>(4 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p2}',
            }, {
                field: 'quarterAgoChange',
                title: 'Quarter<br>(13 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p2}',
            }, {
                field: 'sixMonthsAgoChange',
                title: 'Half Year<br>(26 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p2}',
            }, {
                field: 'yearAgoChange',
                title: 'Year<br>(52 Weeks)',
                width: '10%',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p2}',
            }]
        });
    }

    private updateColumnHeader(field: string, text: string) {
        $(RelativeStrengthLineComparison.GRID + ' th[data-field=' + field + ']')
            .children().html(text);
    }
}
